// extracted by mini-css-extract-plugin
export var contentCentered = "styles-module--contentCentered--7d0c1";
export var image = "styles-module--image--fb5a7";
export var link = "styles-module--link--bae3a";
export var textContent = "styles-module--textContent--f5c03";
export var textContent_alignLeft = "styles-module--textContent_alignLeft--aa118";
export var title = "styles-module--title--1f46a";